export default function validator() {
  return import(
    /* webpackChunkName: "validatorjs" */
    'validatorjs'
  );
}